import { Link } from "react-router-dom";
import { Tunduk } from "@/components/Avatar";
import { UserChip } from "@/components/UserChip";
import { useLang } from "@/context/LangContext";
import { LANGS } from "@/i18n";

export const LangToggle = () => {
  const { lang, setLang } = useLang();
  return (
    <div className="flex rounded-full overflow-hidden border border-[var(--kg-red-border)] bg-black/30" data-testid="language-toggle">
      {LANGS.map((l) => (
        <button key={l} onClick={() => setLang(l)} className={`lang-btn px-2.5 py-1 text-[11px] font-bold uppercase ${lang === l ? "active" : "text-[var(--text-light)]/70"}`} data-testid={`language-toggle-${l}`}>{l}</button>
      ))}
    </div>
  );
};

export const Header = ({ children }) => {
  const { t } = useLang();
  return (
    <header className="flex items-center justify-between py-3" data-testid="app-header">
      <Link to="/" className="flex items-center gap-2" data-testid="header-home-link">
        <Tunduk size={30} />
        <span className="font-display font-extrabold text-sm tracking-tight hidden sm:inline">{t.appTitle}</span>
      </Link>
      <div className="flex items-center gap-2">{children}<UserChip compact /><LangToggle /></div>
    </header>
  );
};
